<template>
  <div>
    <ShipmentDetail
      ref="shipmentDetail"
      :shipmentCode="shipmentCode"
      :disabled="disabled"
      :sourceType="sourceType"
      readonly
    >
    </ShipmentDetail>
  </div>
</template>
<script>
import ShipmentDetail from '@/views/factory/transport/components/shipment-detail'
export default {
  name: 'transport-wait-booking-detail',
  components: {
    ShipmentDetail,
  },
  data() {
    return {
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    query() {
      return this.$route.query
    },
    shipmentCode() {
      return this.params.code
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    sourceType() {
      return this.query.sourceType || ''
    },
  },
}
</script>
